import React from 'react';
import { SettingContext } from '../context/settings/settings';

/**
 * 設定情報用Hook
 */
export const useSettings = () => {
  return React.useContext(SettingContext);
};
